export const getRichtextsInSelection = (sel) => {
  var allSelected = [];

  var range = sel.getRangeAt(0);

  var allWithinRangeParent = [];
  try {
    var allWithinRangeParent =
      range?.commonAncestorContainer.getElementsByTagName("*");
  } catch {}

  if (allWithinRangeParent) {
    for (var i = 0, el; (el = allWithinRangeParent[i]); i++) {
      if (sel.containsNode(el, true)) {
        if (el.classList.contains("grigora-richtext-input__field")) {
          allSelected.push(el);
        }
      }
    }
  }

  return allSelected;
};
